import { render, staticRenderFns } from "./TiketMain.vue?vue&type=template&id=0f37ed5b&"
import script from "./TiketMain.vue?vue&type=script&lang=js&"
export * from "./TiketMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports